<template>
    <van-row class="header_bar">
        <van-col span="2" class="backIcon" style="display: flex; justify-content: center; align-items: center;">
            <img src="@/assets/common/backIcon.png" alt="" @click="handleBackClick">
        </van-col>
        <van-col span="18">
            <van-notice-bar class="notice_container" scrollable speed="50"
                 :text="noticeText">
                <template #left-icon>
                    <img src="@/assets/themeFour/horne.png" alt="">
                </template>
            </van-notice-bar>
        </van-col>
        <van-col span="2" style="display: flex; justify-content: center; align-items: center;">
            <div class="startIcon" @click="addFavorite"
                :style="{ background: isFavorite ? 'linear-gradient(135deg, #f9ff00, #d97e08)' : 'linear-gradient(135deg, #d8e3e9bd, #1b3475c2)' }">
                <van-icon name="star" size="2vh" color="rgb(0, 86, 85)" />
            </div>
        </van-col>
        <van-col span="2" class="walletIcon" style="display: flex; justify-content: center; align-items: center;">
            <img src="@/assets/games/wallet.png" @click="navDeposit" alt="">
        </van-col>
    </van-row>
</template>
<script setup lang="ts">
import { ref} from 'vue'
const props = defineProps<{
    noticeText ?: string,
    isFavorite ?: boolean
}>()
const emits = defineEmits(['backClick', 'showDepositPopup', 'addFavorite'])
const handleBackClick = () => {
    emits('backClick')
}

const addFavorite = () => {
     emits('addFavorite')
}

const navDeposit = () => {
    emits('showDepositPopup')
}

</script>
<style scoped>
.header_bar {
    background: rgb(0, 86, 85) !important;
    color: #ffffffd9;
    z-index: 1000;
    padding: 1.25vh;
}

.backIcon img {
    width: 50%;
}
.backIcon img:hover{
    padding: 5px 10px;
    border-radius: 30px;
    background: #ffffff17;
}

.van-notice-bar {
    background: linear-gradient(90deg, #ff570300, #79787e42, #dfdede00);
    font-size: 15px;
    color: rgb(94, 172, 171);
    padding: 0;
    font-weight: 400;
}

.notice_container img {
    width: 10%;
    padding-right: 5px;
}

.startIcon {
    width: 2.5vh;
    height: 2.5vh;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    background: linear-gradient(135deg, #c3bdb5, #eeeeeee8);

}

.walletIcon img {
    height: 3.5vh;
}
</style>